module.exports = __webpack_public_path__ + "img/shequ4.57fb810d.png";